import React, { useState, useRef, useContext } from "react";
import "./RenameLedger.css";
import headeLogo from "../../assets/images/shersoftnavLogo.png";
import close from "../../assets/images/CreateCompanyImages/Wrong (1).webp";
import ComboBox from "../../components/ComboBoxes/ComboBox";
import crtCmp from "../../assets/images/CreateCompanyImages/CreateCmp.webp";
import exit from "../../assets/images/CreateCompanyImages/Cdbexit.webp";
import { AuthContext } from "../../context/AuthContext";
import { useDbContext } from "../../context/DbContext";
import axios from "axios";
function RenameLedger({ onClose, LedName }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const [newLedname, setNewLedname] = useState(LedName);
  // //////console.log(newLedname);
  const handleUpdate = async () => {
    if (newLedname === "") {
      alert("Enter New LedgerName");
      return;
    }
    try {
      {
        const response = await axios.put(
          `${apiBaseUrl}/main/renameLed/${dbCode}/${LedName}/${newLedname}`
        );

        if (response.status === 200) {
            alert("Ledger Renamed");
            onClose();
        } else {
          // Handle other response statuses or errors
          console.error("Error updating data:", response.data);
        }
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error("Error:", error.message);
    }
  };

  const { agentCode } = useContext(AuthContext);

  return (
    <div className="renameLedroot  absolute w-6/12 h-1/3 bg-white shadow-md rounded-md flex flex-col ">
      <div className="w-full h-[25%] flex gap-5 items-center justify-center">
        <div className="w-1/2 h-full flex items-center gap-2 pl-2">
          <img src={headeLogo} alt="SS" />
          <label className="font-Inter">Rename Ledger</label>
        </div>
        <div className="w-1/2 h-full flex  gap-2 pr-1 relative">
          <button
            className=" bg-[red] h-[22px] w-auto  border-none rounded-sm  absolute right-2 top-1 "
            onClick={onClose}
          >
            <img src={close} alt="X" className="h-[13px] w-[13px]" />
          </button>
        </div>
      </div>

      <div className="w-full h-[25%] flex gap-5 items-center justify-center">
        <label htmlFor="oldled " className="w-[20%] font-Inter">
          Old Ledger
        </label>
        <input
          type="text"
          id="oldled"
          className="h-3/6 w-2/3"
          readOnly
          value={LedName}
        />
      </div>
      <div className="w-full h-[25%] flex gap-5 items-center justify-center">
        <label htmlFor="newled" className="w-[20%] font-Inter">
          New Ledger
        </label>
        <input
          value={newLedname}
          type="text"
          id="newled"
          className="h-3/6 w-2/3"
          onChange={(e) => setNewLedname(e.target.value)}
        />
      </div>
      <div className="w-full h-[25%] flex gap-5 items-center justify-center">
        <label htmlFor="newled" className="w-[20%] font-Inter"></label>
        <button className="w-[31.5%] h-4/6 p-0" onClick={handleUpdate}>
          Rename
        </button>
        <button className="w-[31.5%] h-4/6 p-0" onClick={onClose}>
          Exit
        </button>
      </div>
    </div>
  );
}

export default RenameLedger;
